import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { JournalIntervalCumulativeDecisionSummary } from 'donor-elf-web/lib/journal-utils';
import FundModel from 'donor-elf-web/models/fund';
import JournalModel from 'donor-elf-web/models/journal';
import JournalGoalModel from 'donor-elf-web/models/journal-goal';
import FundsService from 'donor-elf-web/services/funds-service';

interface ComponentArgs {
  journal: JournalModel;
  journalGoal: JournalGoalModel;
  fund: FundModel;
  // intervalSummaries must only be for the decisions related to the journalGoal
  intervalSummaries: JournalIntervalCumulativeDecisionSummary[];
}

export default class JournalSummaryCard extends Component<ComponentArgs> {
  @service declare fundsService: FundsService;
  @service declare abilities: any;

  get isIntervarsityUser() {
    return this.abilities.hasAbility('import_iv_prospects');
  }

  get decisionsMadeLabel() {
    return this.isIntervarsityUser ? 'Journal Pledges' : 'Decisions Made';
  }

  viewJournal = () => {
    this.fundsService.viewFund(this.args.fund.id, {
      urlPath: `journals/${this.args.journal.id}`,
    });
  };
}
